<template>
    <div>
        <v-app>
            <v-card class="window-card">
                <v-card-title>
                    <span class="md-title" style="color: #67ad5b">选择场景</span>
                </v-card-title>
                <v-card-text>
                    <v-select :items="courseList" item-text="name" item-value="_id" filled clearable dense label="课程"
                        v-model="form.course" @input="filterProject"></v-select>

                    <v-select :items="projectList" item-text="name" item-value="_id" filled clearable dense label="项目"
                        v-model="form.project" @input="filterScene"></v-select>

                    <v-select :items="modList" item-text="name" item-value="_id" filled clearable dense label="设备模型"
                        v-model="sceneId"></v-select>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn color="success" @click="confirm">确 定</v-btn>
                    <v-btn color="success" @click="cancel">关 闭</v-btn>
                </v-card-actions>
            </v-card>
        </v-app>
    </div>
</template>
<script>
import { listCourse } from '@/api/course'
import { listProject } from '@/api/project'
import { listDeviceModelDefinition } from '@/api/modelDefinition/deviceModelDefinition'
export default {
    data() {
        return {
            lockview: '',
            courseList: [],
            projectList: [],
            course: '',
            sceneId: '629dfc5fd809c3365b8adf26',
            checkedSceneId: '629dfc5fd809c3365b8adf26',
            form: {},
            show: false,
            projectDisabled: true,
            modList: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            const courseResult = await listCourse()
            if (courseResult.code == 200) {
                this.courseList = courseResult.data.rows
            }
        },
        async filterProject(item) {
            const projectResult = await listProject({
                course: item._id,
                perPage: 500
            })
            if (projectResult.code == 200) {
                this.projectList = projectResult.data.rows
                this.projectDisabled = false
            }
        },
        async filterScene() {
            const result = await listDeviceModelDefinition({
                perPage: 100,
                ...this.form
            })

            const { code, data } = result

            if (code == 200) {
                this.modList = data.rows
            }

        },

        confirm() {
            const index = this.modList.findIndex(item => item._id === this.sceneId)
            this.$emit('handleConfirm', this.modList[index])
        },
        cancel() {
            this.$emit('handleCancel', {})
        }
    }
}
</script>
<style>
</style>